/**
 * @module line/paragraphspacing
 */

import LineUI from '../lineui';

/**
 * The default paragraphspacing UI plugin.
 *
 * It introduces the `'paragraphspacing'` dropdown.
 *
 * @extends LineUI
 */
export default class ParagraphSpacingUI extends LineUI {

	/**
	 * @inheritDoc
	 */
	static get pluginName() {
		return 'ParagraphSpacingUI';
	}

	constructor( editor ) {
		super( editor, 'paragraphspacing', 'normal', 'Entre parágrafos', 'Espaçamento entre parágrafos' );
	}
}
